// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"7b42f52cb9c12a3ee167","655":"82868d2921da53d6b38d"}[chunkId] + ".js";
};